const postList = () => import('@/pages/community/post/index.vue');
const postDetail = () => import('@/pages/community/post/detail.vue');

export default [{
    path: '/community/post',
    component: postList,
    meta: [{
        name: '社区管理'
    },
    {
        name: '帖子列表',
        activeRoute: '/community/post'
    }]
}, {
    path: '/community/post/detail',
    component: postDetail,
    meta: [{
        name: '社区管理'
    }, {
        name: '帖子列表',
        url: '/community/post'
    }, {
        name: '帖子详情',
        activeRoute: '/community/post'
    }]
}];